import { prop, needs } from "fw";
import { AtsUser } from "models/ats-user";
import { AtsLoginButton } from "views/components/ats-login-button";
import { UserInfo } from "./user-info";
import { ConfirmService } from "service/confirm-service";
import { Notification } from "service/notification";
import { AtsRepository } from "../../network/ats-repository";

@needs(AtsLoginButton, UserInfo)
export class PanelUsers {
    @prop(null) user: AtsUser;

    constructor(
        private atsRepo: AtsRepository,
        private notifier: Notification,
        private confirmService: ConfirmService
    ) {}

    get hasAddressData() {
        if (this.user.Address != null) {
            return Object.values(this.user.Address).join("").length > 0;
        } else {
            return false;
        }
    }

    initial(word: string) {
        return word ? word.substr(0, 1).toUpperCase() : "";
    }

    get avatar() {
        return {
            initials: this.initial(this.user.FirstName) + this.initial(this.user.LastName),
            bgColor: this.user.MetaData.ProfileColor || "#767676",
            image: this.user.MetaData.AvatarEphemeralUrl
        };
    }

    public async disable2FA() {
        const confirm = await this.confirmService.confirm({
            title: "Disable Two-Factor Authentication (2FA)",
            message: "Disabling Two-Factor Authentication (2FA) for this user will be logged and cannot be undone. Are you sure you want to proceed?"
        });
        if (confirm) {
            await this.atsRepo.deactivateMfa(this.user.Id);
            this.notifier.notify("2FA disabled for user " + this.user.FirstName + " " + this.user.LastName + ".");
            this.user = await this.atsRepo.userById(this.user.Id);
        }
    }
}
